import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { HanaMainBanner } from '@crehana/hana-ai/HanaMainBanner';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col } from '@crehana/ui';
import { useRouter } from 'next/router';

import { PANEL_PATH } from '../../../routes';

export const HanaBanner: React.FC<{ slug: string }> = ({ slug }) => {
  const { logEvent } = useAmplitude();
  const { push } = useRouter();

  const handleNavigateToHanaPanel = () => {
    push({
      pathname: PANEL_PATH.HANA_AI.replace('[slug]', slug),
      query: { source_page: 'Banner Home' },
    });

    logEvent({
      event: 'Click Banner Hana',
      data: {
        ...getSourceEventParams(),
        Organization: slug,
      },
    });
  };

  return (
    <Col style={{ maxWidth: '1070px' }}>
      <HanaMainBanner
        className="tw-max-h-12"
        onNavigate={handleNavigateToHanaPanel}
      />
    </Col>
  );
};
